import { render } from "./YearlyContent.vue?vue&type=template&id=42b65bb2&scoped=true"
import script from "./YearlyContent.vue?vue&type=script&lang=js"
export * from "./YearlyContent.vue?vue&type=script&lang=js"

import "./YearlyContent.vue?vue&type=style&index=0&id=42b65bb2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b65bb2"]])

export default __exports__